import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import PortfolioPage from '../components/PortfolioPage'


const Home = styled.div`
	width: 100%;
	height: 100vh;
	background-image: url("https://res.cloudinary.com/katjakrug/image/upload/v1535890059/Back_2.jpg");
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	z-index: 0;
	position: relative;
`

const HomeText = styled.div`
	padding-top: 40vh;
	text-align: center;

	@media (max-width: 620px){
		padding-top: 25vh;
	}
`

const Title = styled.h1`
	font-weight: 500;
	text-rendering: optimizeLegibility;
	font-size: 70px;
	color: white;
	display: inline-block;

	@media (max-width: 620px){
		font-size: 48px;
	}
`

const Name = styled.p`
	font-size: 30px;
	font-weight: 300;
	color: white;
	margin-top: -1vh;
	margin-bottom: 3vh;

	@media (max-width: 620px){
		font-size: 22px;
		margin-bottom: 5vh;
	}
`

const ScrollLink = styled(Link)`
	width: 250px;
	height: 55px;
	margin: auto;
	border-style: solid;
	border-width: 0.5px;
	color: white;
	display: flex;
    justify-content: center;
    align-items: center;
	text-decoration: none;
	font-weight: 300;

	&:hover {
		border-width: 3px;
	}

	@media (max-width: 620px){
		width: 200px;
		height: 45px;	
		margin-top: -1vh;
	}
`

export default class HomePage extends React.Component {
	render() {
		const {location} = this.props.history
		return (
			<div>

				<PortfolioPage location={location}/>
			</div>

		)
	}
}




// WEBPACK FOOTER //
// ./src/pages/index.js